import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=547a1604&scoped=true&"
import script from "./DashboardContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardContainer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContainer.vue?vue&type=style&index=0&id=547a1604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a1604",
  null
  
)

export default component.exports